import React from 'react';
import { XIcon } from 'assests/GmsIcons';

type ConfirmDialogProps = {
    id: string;
    title: string;
    message: string;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmDialog = ({id, title, message, onClose, onConfirm}: ConfirmDialogProps) => {

    return (
        <div id={id} className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-[38%] tw-h-auto`}>
                <div className='tw-flex tw-justify-between tw-items-center'>
                    <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>{title}</h2>
                    <button className='tw-mr-2' onClick={onClose}><XIcon /></button>
                </div>
                <label className='tw-text-sm tw-text-[#747593] tw-block tw-px-3'>{message}</label>
                <div className={`tw-px-3 tw-my-4 tw-flex tw-gap-2 tw-justify-end`}>
                    <button onClick={onClose} className='samll-outline-btn'>No</button>
                    <button onClick={onConfirm} className='small-filled-btn'>Yes</button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmDialog;